<template>
    <ReferralLayout :showFooterFaq="false" :showFooterGallery="true">
        <inertia-head>
            <title>{{$t('referrers.meta_lead_title')}}</title>
            <meta property="og:title" :content="$t('referrers.meta_lead_og:title')">
            <meta property="og:description" :content="$t('referrers.meta_lead_og:description')">
            <meta property="og:image" :content="ogHref">
            <meta property="og:url" :content="ogImage">
            <meta property="og:site_name" :content="$t('referrers.meta_lead_og:site_name')">
            <meta property="og:type" :content="$t('referrers.meta_lead_og:type')">
        </inertia-head>
        <div>
            <HomeCard :referralPartner="referralPartner"/>
            <v-row class="mb-16">
                <v-col cols="12" sm="12" md="8" lg="8" xl="8">
                    <FormStepperSimple :errors="errors"/>
                </v-col>
                <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                    <GoogleReviews/>
                </v-col>
            </v-row>
        </div>
    </ReferralLayout>
</template>

<script>
import HomeCard from "../../Components/ReferralCampaigns/index/HomeCard";
import GoogleReviews from "../../Components/ReferralCampaigns/index/GoogleReviews";
import ReferralLayout from "../../Layouts/ReferralLayout";
import FormStepperSimple from "../../Components/ReferralCampaigns/index/FormStepperSimple.vue";

export default {
    name: "Friend",
    components: {
        FormStepperSimple,
        HomeCard,
        GoogleReviews,
        ReferralLayout,
    },
    props: {
        referralPartner: {
            type: Object
        },
        errors: {
            type: Object,
            required: false,
        },
    },
    computed: {
        ogHref() {
            return window.location.href;
        },
        ogImage() {
            return window.location.origin + "/img/og-image.jpg"
        }
    }
}
</script>

<style>

</style>
